module.exports = __webpack_public_path__ + "static/img/3366_phase_function_Paper_Points.fe25ee4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/3366_phase_function_Paper_Points.png
// module id = IeS1
// module chunks = 0